import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface TaskCreatedEvent {
    taskId?: string;
    taskName?: string;
    timestamp: Date;
}

export interface TaskDeletedEvent {
    taskId: string;
    timestamp: Date;
}

export interface TaskStatusChangedEvent {
    taskId: string;
    newStatus: number;
    timestamp: Date;
}

@Injectable({
    providedIn: 'root',
})
export class TaskEventService {
    private readonly taskCreated$ = new Subject<TaskCreatedEvent>();
    private readonly taskDeleted$ = new Subject<TaskDeletedEvent>();
    private readonly taskStatusChanged$ = new Subject<TaskStatusChangedEvent>();


    onTaskCreated(): Observable<TaskCreatedEvent> {
        return this.taskCreated$.asObservable();
    }


    onTaskDeleted(): Observable<TaskDeletedEvent> {
        return this.taskDeleted$.asObservable();
    }


    onTaskStatusChanged(): Observable<TaskStatusChangedEvent> {
        return this.taskStatusChanged$.asObservable();
    }


    publishTaskCreated(event: TaskCreatedEvent): void {
        this.taskCreated$.next(event);
    }


    publishTaskDeleted(event: TaskDeletedEvent): void {
        this.taskDeleted$.next(event);
    }


    publishTaskStatusChanged(event: TaskStatusChangedEvent): void {
        this.taskStatusChanged$.next(event);
    }
}
